export enum PATHS{
    PRODUCTS_PATH = '/products',
    MAIN_SOLUTION_PATH = '/main-solutions',
    CONTACT_EMAIL_NUMBER_PATH = '/email-service/email-number-contact-message',
    FORM_CONTACT_MESSAGE = '/email-service/form-contact-message',
    OFFER_LANDING='/offer-landing',
    DATA_LANDING_FILE='/data-landing-nuna-key'
}